import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Section = styled.section`
  padding: 3rem 1rem;
  background: var(--background-light);
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 1.75rem;
  margin: 0 0 0.5rem;
  color: var(--text-color);
`;

const Sub = styled.p`
  color: var(--text-secondary);
  margin: 0 auto 2rem;
  max-width: 600px;
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
`;

const Chip = styled(Link)`
  padding: 0.6rem 1.25rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(0, 153, 0, 0.05);
  color: var(--text-color);
  text-decoration: none;
  font-size: 0.95rem;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: rgba(0, 153, 0, 0.15);
    border-color: var(--primary-color);
  }
`;

const TOPICS = [
  'Flash USDT',
  'USDT Tutorials',
  'TRC-20',
  'ERC-20',
  'Stablecoins',
  'Blockchain Basics',
  'Wallet Security',
  'Crypto Trading',
];

const TopicsStrip: React.FC = () => (
  <Section>
    <Inner>
      <Heading>Explore by topic</Heading>
      <Sub>Jump into the areas you care about most.</Sub>
      <Chips>
        {TOPICS.map((t) => (
          <Chip key={t} to={`/blog?topic=${encodeURIComponent(t.toLowerCase())}`}>
            {t}
          </Chip>
        ))}
      </Chips>
    </Inner>
  </Section>
);

export default TopicsStrip;
